import React from "react";
import { Navigate } from "react-router-dom";
import token from "../../utils/token";
import ClientsQueries from "../../requests/queries/ClientsQueries";
import LoadingSpinner from "./Loading";

export default function ProtectedPage({ children, permissionsNeeded, needToBeAuthenticated = false, redirectPath = '/', currentCommand: propCurrentCommand, setCurrentCommand: propSetCurrentCommand }) {

  const [isLoading, setIsLoading] = React.useState(true);
  const [internalCurrentCommand, setInternalCurrentCommand] = React.useState(null);
  
  const currentCommand = (propCurrentCommand !== undefined && propCurrentCommand !== null) ? propCurrentCommand : internalCurrentCommand;
  const setCurrentCommand = propSetCurrentCommand || setInternalCurrentCommand;
  
  const fetchClientAuthentication = async () => {
    const isAuthenticated = await isClientAuthenticated();
    if(!isAuthenticated.authenticated) {
      window.location.href = redirectPath;
    }
    if(isAuthenticated.current_command) {
      if(propSetCurrentCommand) {
        propSetCurrentCommand(isAuthenticated.current_command);
      } else {
        setInternalCurrentCommand(isAuthenticated.current_command);
      }
    }
    setIsLoading(false);
  }

  const fetchToken = async () => {
    if(permissionsNeeded === 'client') {
      const clientToken = await token.client_token.getToken();
      if(!clientToken) {
        window.location.href = redirectPath;
      } else {
        setIsLoading(false);
      }
    }
  }

  React.useEffect(() => {
    if(permissionsNeeded === 'client' && !needToBeAuthenticated) {
      fetchToken();
    }
    if(permissionsNeeded === 'client' && needToBeAuthenticated) {
      fetchClientAuthentication();
    } else {
      setIsLoading(false);
    }
  }, [permissionsNeeded, needToBeAuthenticated, redirectPath, propSetCurrentCommand]);
  
  if(permissionsNeeded === 'user' && !token.user_token.getToken() || permissionsNeeded === 'client' && !token.client_token.getToken()) {
    return <Navigate to={redirectPath} />;
  }


  if(isLoading) {
    return <LoadingSpinner />;
  }

  return (
    <>
      {React.Children.map(children, child => {
        if (!React.isValidElement(child)) return child;
        // Ne pas passer currentCommand/setCurrentCommand aux éléments DOM (div, etc.)
        const isDomElement = typeof child.type === 'string';
        return React.cloneElement(child, isDomElement ? undefined : { 
          currentCommand, 
          setCurrentCommand 
        });
      })}
    </>
  );
}

const isClientAuthenticated = async () => {
  const res = await ClientsQueries.isAuthenticated();
  return res;
}